import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import { Table } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import swal from 'sweetalert';
import WaitingModal from '../generics/WaitingModal';

var Config = require('../../config');

class ModalPrintLabel extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.openPDF = this.openPDF.bind(this);
		this.onChangePlantilla = this.onChangePlantilla.bind(this);
		this.printingLabel = this.printingLabel.bind(this);

		this.state = {
		    show: false,
		    number_templates:"",
		    label_type:"",
		    opening:false,
		    options:[],
		    register_id:"",
		    template_number:"", 
		    labels:[],
			type_extraction_name:"",
			functional_criterial:{}
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(label_type,register_id, extraction, open, functional_criterial, screen='reprint') {
		this.setState({functional_criterial:functional_criterial, screen:screen});

		var url = '';

		if(extraction === null || extraction === undefined)
			url = 'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type='+label_type+'&extraction_type=';
		else if(extraction === 'ST'){
			this.setState({
				type_extraction_name: 'SANGRE_TOTAL'
			});

			url = 'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type='+label_type+'&extraction_type=SANGRE TOTAL';
		}else{
			this.setState({
				type_extraction_name: 'AFÉRESIS'
			});

			url = 'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type='+label_type+'&extraction_type=AFÉRESIS';
		}

		fetch(Config.default.apiGateway.URL+url,{ 
			method: 'get',
			headers: new Headers({
			   	'Authorization': 'Bearer ' + sessionStorage.getItem("token"), 
			   	'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {

			if(response.res === 0){
				swal('Error', 'No existen formatos definidos para este tipo de impresión.', 'error');
			}else{
				if(open !== undefined){
					console.log('registro')
					this.setState({
						register_id:register_id,
						label_type: label_type
					})
					this.printingLabel([]);
				}else{
					this.setState({
						show: true,
						number_templates:response.res,
						register_id:register_id,
						template_number:[],
						options:[],
						opening:false,
						label_type: label_type
					})
				
					var opt = []

					for(var i = 0; i <= parseInt(response.res,10); i++){	
						if(i === 0){
							opt.push({value:i, check:false});
						}else{
							opt.push({value:i-1, check:false});
						}			
					}
					this.setState({
						options: opt
					});
				}
					
			}
		})
	}

	//Evento de cambio en elementos formulario
	handleChange = (event, index, value) => {
	    this.setState({
	      [event.target.name]: event.target.value
	    });

	    if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && event.target.value===""){
				control.classList.add('error');
			  }
			}
		}
	}

	openPDF(id){
		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');
		var etiqueta = []

		if(ctrls[0].checked){
			etiqueta.push(parseInt(ctrls[0].value));
		}else{
			ctrls.forEach(function(ctrl, i){
				if(ctrl.checked){
					etiqueta.push(parseInt(ctrl.value));
				}
			})
		}
		

		if(etiqueta.length > 0){
			this.printingLabel(etiqueta);
		}else{
			swal('Error', 'Debe seleccionar una plantilla', 'error');
		}
		
	}

	printingLabel(etiqueta){
		var obj ={
			health_facilities_id : sessionStorage.getItem("health_facilities_id"),
			id : this.state.register_id.toString(),
			file_type : this.state.label_type,
			nEtiqueta : etiqueta,
			name : this.state.type_extraction_name,// == "SANGE TOTAL"?"SANGRE_TOTAL":"AFÉRESIS";
		}

		var apiUrl = "labelsEditor";

		if(this.state.screen === 'multiple'){
			apiUrl = "labelsEditor/reprint_labels";

			obj = {
				health_facilities_id : sessionStorage.getItem("health_facilities_id"),
				file_type : this.state.label_type,
				name : this.state.type_extraction_name,// == "SANGE TOTAL"?"SANGRE_TOTAL":"AFÉRESIS";
				labels:etiqueta,
				ids:this.state.register_id
			};
		}

		this.props.waiting.handleShow('Imprimiendo...');


		fetch(Config.default.apiGateway.URL+apiUrl, {
		
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
				'Content-Type': 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
                return;
              });
            }
		})
		.then(response => {
			if(response !== undefined){
				if(this.state.functional_criterial.value ==="NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					this.props.directPrint(response, this.state.label_type);
				}
				
				if(this.state.screen !== 'multiple' && 
					this.state.screen !== 'bag_entries'
				){
					this.traceability();	
				}
				
				this.handleClose();
       		}
		})
	}

	traceability(){
		var obj = {
			action: this.state.label_type === 'label_register' ? 'OFFERS' : 'DONATIONS',
			offers_id: this.state.register_id,
			description:this.state.screen === 'reprint' ? 'REPRINT' : 'PRINT'
		}
		fetch(Config.default.apiGateway.URL+'traceabilities/reprint',{
			method:'POST',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then((res)=>{
			if(res.ok){
				return 'correcto';
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({ show: false});
			}
		})
	}

	onChangePlantilla(e){

		var options = this.state.options;

		const select = document.querySelector('div.modal-body');
		const ctrls = select.querySelectorAll('input');

		ctrls.forEach(function(ctrl, i){
			if(ctrls[0].name == e.target.name){
				if(ctrls[0].checked){
					options[i].check = true;
				}else{
					options[i].check = false;
				}				
			}else{
				if(ctrl.name === e.target.name){
					if(ctrl.checked){
						options[i].check = true;

						var check = 1;
						options.map(function(opt, j){
							if(j > 0 && opt.check)
								check++;
						})

						if(check === options.length)
							options[0].check = true;

					}else{
						if(ctrls[0].checked){
							options[0].check = false;
							options[i].check = false;
						}else{
							options[i].check = false;
						}
					}
				}
			}
		})

		this.setState({
			options: options
		})
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });
	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}

		return res;
	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_print_label.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        {this.state.opening?
		        	<div style={{textAlign:'center'}}>
						<Loader 
							type="Oval" 
							color="#64b5f6" 
							height={80} 
							width={80}
							/> 
					</div>
				:
		        	<div className="row" style={{padding:"0px 20px 0px 20px"}}>
				        <div className="col-xs-12 col-sm-5 col-sm-offset-4" >
							<Table responsive hover>
								<thead>
									<tr>
										<th></th>
										<th>Plantillas</th>
									</tr>
								</thead>
								<tbody>
									
									{this.state.options.lenght !== 0 ?
										this.state.options.map((option, i)=>(
											<tr key={i}>
											
												<td>
													<input type="checkbox" value={option.value} name={'o'+i} id={'o'+i} 
													 onChange={this.onChangePlantilla} checked={option.check}/>
												</td>
												<td>{i === 0 ? 'Todos' : i}</td>
										
											</tr>
										))
									: null
									}
									
								</tbody>
							</Table>
							{/*
							<select className="form-control" value={ this.state.template_number || ""} 
								onChange={ this.handleChange.bind(this) } name="template_number" id="template_number" required>
								<option value="" disabled>Seleccionar...</option>
								{
									this.state.options.map(function(t) {
										return <option key={t.id} value={t.id} >{t.value}</option>;
									})
								}
							</select>
						*/}
						</div>
				    </div>}
		        </Modal.Body>
		        <Modal.Footer>
		        <FlatButton primary={true} label={t('content.generics.buttons.print')}  onClick={this.openPDF}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>

		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalPrintLabel) 